import { useRouterState } from "@tanstack/react-router";
import { Fragment, type ReactNode } from "react";

export function RemountOnPageUuid({ children }: { children: ReactNode }) {
    const pageLoadUuid = useRouterState({ select: (s) => s.location.state?.pageLoadUuid });
    return <Fragment key={pageLoadUuid}>{children}</Fragment>;
}
